
var xlsx = require('xlsx');
var excel_grid_data = [];
function getExcelSheetDataView(_this,file){
    // Read the Excel File data.
    var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.xls|.xlsx)$/;
    if (regex.test(file.name.toLowerCase())) {
        if (typeof (FileReader) != "undefined") {
            var reader = new FileReader();
            //For Browsers other than IE.
            if (reader.readAsBinaryString) {
                reader.onload = function (e){
                    var edata =ProcessExcel(e.target.result,_this);
                    _this.dataSource=edata;
                    console.log(_this.dataSource);
                  //  _this.Exceldata=edata;
                    // _this.Exceldata = edata;
                } 
                reader.readAsBinaryString(file);
            }
        }
     }
}

//get ledger sheet headers
function get_header_row(data) {
    var excel_grid_data_obj = {};
   
    var XLSX = require('xlsx');
    var workbook = XLSX.read(data, {
       type: 'binary'
    });
    
    var headers = [];
    var range = XLSX.utils.decode_range(workbook.Sheets.Sheet1['!ref']);
    var C, R = range.s.r; /* start in the first row */
    /* walk every column in the range */
    // for (C = range.s.c; C <= range.e.c; ++C) {
    //    var cell = workbook.Sheets.Sheet1[XLSX.utils.encode_cell({ c: C, r: R })] /* find the cell in the first row */
    //    var hdr = "UNKNOWN " + C; // <-- replace with your desired default 
    //    if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
    //    if(headers.indexOf(hdr) == -1){
    //       headers.push(hdr);
    //    }
    // }

    for (C = range.s.c; C <= range.e.c; ++C) {
        var cell = workbook.Sheets.Sheet1[XLSX.utils.encode_cell({ c: C, r: R })] /* find the cell in the first row */
        var hdr = "UNKNOWN " + C; // <-- replace with your desired default 
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        excel_grid_data_obj[hdr] = hdr;
    }
    excel_grid_data.push(excel_grid_data_obj);
    return excel_grid_data;
 }

function ProcessExcel(data,_this){
    //Read the Excel File data.
    var XLSX = require('xlsx');
    var workbook = XLSX.read(data, {
        type: 'binary'
    });

    //console.log(massage(workbook));
    //Fetch the name of First Sheet.
    var firstSheet = workbook.SheetNames[0];
    
    //Read all rows from First Sheet into an JSON array.
    var excelRows = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[firstSheet]);
    

    return excelRows;
    //Display the data from Excel file in Table.
};
//function for reading excel files
const massage = wb => {
    const out = [];
    wb.SheetNames.forEach(name => {
        const o = { name, rows: {} };
        const ws = wb.Sheets[name];
        const aoa = xlsx.utils.sheet_to_json(ws, { raw: false, header: 1 });
        aoa.forEach((r, i) => {
            const cells = {};
            r.forEach((c, j) => {
                cells[j] = { text: c };
            });
            o.rows[i] = {
                cells
            };
        });
        out.push(o);
    });
    return out;
};
//read function ends



export{getExcelSheetDataView}